<template>
  <div
    v-show="fetchedSetting"
    class="auth-wrapper auth-v1 px-2"
  >
    <div class="auth-inner py-2">
      <b-card-title class="mb-1 text-center">
        <!-- {{ $t('auth.login.welcome',{'app_name': $app_name}) }} -->
        {{ $app_name }}
      </b-card-title>
      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!-- logo -->
          <VOVAT-logo :img-width="120" />
          <h2 class="brand-text text-primary ml-1">
            Tin tức
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          {{ $t('auth.forgot_password') }}? 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          {{ $t('auth.forgot_password_hint') }}
        </b-card-text>

        <!-- form -->
        <validation-observer
          ref="forgetPasswordForm"
          #default="{ handleSubmit }"
        >
          <b-form
            class="auth-forgot-password-form mt-2"
            autocomplete="off"
            @submit.prevent="handleSubmit(validationForm)"
          >

            <div
              v-for="(item, index) in getForgotpassPoll"
              :key="'question' + index"
              border-variant="secondary"
            >
              <b-form-group :label="item.question" />
              <validation-provider
                #default="{ errors }"
                name="Câu trả lời"
                rules="required"
              >
                <b-form-group>

                  <b-input-group
                    v-for="(answer, answer_index) in item.answer"
                    :key="'answer' + answer_index"
                    class="mb-1"
                    :label="answer"
                    :class="{ 'is-invalid': validateRadio(errors) !== null, 'is-valid': validateRadio(errors) }"
                  >
                    <label
                      class="form-control"
                      :for="'isanswer' + answer_index"
                      :class="{ 'is-invalid': validateRadio(errors) !== null, 'is-valid': validateRadio(errors) }"
                    >{{ answer }}</label>
                    <b-input-group-append is-text>
                      <b-form-radio
                        :id="'isanswer' + answer_index"
                        v-model="settings.isAnswer"
                        :value="answer_index"
                        name="isanswer"
                        :state="validateRadio(errors)"
                      />

                    </b-input-group-append>
                  </b-input-group>
                  <small
                    v-if="errors.length"
                    id="error_radio"
                    class="text-danger"
                  >{{ errors[0] }}</small>
                  <small
                    v-else
                    class="text-danger"
                  >{{ poll_error }}</small>
                </b-form-group>
              </validation-provider>

            </div>
            <!-- email -->
            <b-form-group
              label="Email"
              label-for="forgot-password-email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="forgot-password-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false : null"
                  name="forgot-password-email"
                  placeholder="email@example.com"
                  autocompl
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              block
              type="submit"
              :disabled="loading || isForgot"
            >
              {{ $t('auth.send_reset_link') }}
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <b-link :to="{ name: 'auth-login-v1' }">
            <feather-icon icon="ChevronLeftIcon" /> {{ $t('auth.back_to_login') }}
          </b-link>
        </b-card-text>

      </b-card>
      <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VOVATLogo from '@core/layouts/components/Logo.vue'
import {
  BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BForm, BButton,
  BInputGroup,
  BInputGroupAppend,
  BFormRadio,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import useJwt from '@/auth/jwt/useJwt'
import { showToast } from '@/@core/utils/utils'
import { faL } from '@fortawesome/free-solid-svg-icons'

export default {
  components: {
    VOVATLogo,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    BInputGroup,
    BInputGroupAppend,
    BFormRadio,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      // validation
      required,
      email,
      fetchedSetting: false,
      settings: {
        all_forgotpass_polls: [],
        forgotpass_polls: [],
        isAnswer: -1,
      },
      poll_error: '',
      isForgot: false,
      loading: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchSetting();
    });
  },
  computed: {
    getForgotpassPoll: {
      get() {
        return this.settings.forgotpass_polls;
      },
      set(val) {
        this.settings.forgotpass_polls = val;
        return val;
      },
    },
    cookieForgot2() {
      return this.$cookies.get('VOVNewsPortalForgotPassword')
    },
  },
  mounted() {
    this.preventSubmitForm()
  },
  methods: {
    preventSubmitForm() {
      const cookieForgot = this.$cookies.get('VOVNewsPortalForgotPassword');
      // console.log('cookieForgot', cookieForgot);
      if (cookieForgot) {
        showToast('Bạn đã yêu cầu lấy lại mật khẩu trước đó. Vui lòng quay lại sau ít phút');
        this.loading = true
        this.isForgot = true
        return false;
      }
      return true;
    },
    validationForm() {
      // valid cookie
      const allowSendMail = this.preventSubmitForm();
      if (!allowSendMail) return;
      // submit form
      this.$refs.forgetPasswordForm.validate().then(success => {
        const isValidPoll = this.validPoll();
        this.poll_error = !isValidPoll ? 'Câu trả lời không đúng' : '';
        if (success && isValidPoll) {
          this.loading = true
          useJwt
            .forgotpass({
              email: this.userEmail,
            })
            .then(response => {
              this.loading = false
              if (response.status === 200) {
                showToast('Mật khẩu đã được gửi tới mail của bạn. Vui lòng kiểm tra mail và làm theo hướng dẫn.', {
                  variant: 'success',
                })
                this.isForgot = true
                this.$cookies.set('VOVNewsPortalForgotPassword', 1, 1 * 60); // 5 min
              }
            })
        }
        return false;
      })
    },
    fetchSetting() {
      this.$store.dispatch('settings/getListByAuthGroup').then((res) => {
        if (res.status === 200) {
          if (res.data.code === 200) {
            this.$store.commit('app/UPDATE_PAGE_LOADING', false);
            if (res.data.data && res.data.data.forgotpass_polls) {
              const items = res.data.data.forgotpass_polls;
              items.sort(() => Math.random() - 0.5);
              this.settings.all_forgotpass_polls = items
              this.settings.forgotpass_polls = items.slice(0, 1)
            }
            this.fetchedSetting = true;
          }
        }
      })
    },
    validateRadio(errors) {
      return errors.length > 0 ? false : null
    },
    validPoll() {
      if (this.settings.forgotpass_polls.length) {
        let isValid = false;
        this.settings.forgotpass_polls.forEach((item, index) => {
          if (this.settings.isAnswer === item.isAnswer) {
            isValid = true;
          }
        });
        return isValid;
      }
      return true;
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
